<template>
  <div>
    <div class="g-kanban pt-4">
    <div class="coluna-kanban" v-for="c in colunas" :key="c.id">
      <!-- Nome da coluna/status vindo do banco -->
      <div class="head-kanban">
        <div class="nomecoluna">{{ c.name }}</div>
        <div :id="c.value + '-total'" class="classtotal">{{ c.lstREOccurence == null ? 0 : c.lstREOccurence.length }}</div>
      </div>
        <div class="body-kanban">
          <draggable
          :animation="200"
          :id="c.value"
          :v-model="c.lstREOccurence"
          group="people"
          @start="drag"
          @end="alteracao"
          item-key="id"
        >
          <!-- Cards dentro da coluna -->
          <div v-for="(data, index) in c.lstREOccurence" :key="index"  @click="detalhe(data)" :id="data.id" class="item-kanban">
            <div class="status-kaban-item" :style="'background-color:' + data.colorStusOcorencia"></div>
            <img class="iconeimagem" v-bind:src="iconselector(data.patalogia)" />
             <div class="p-2 w-100">
              <div class="name-user">{{validaNomeUser(data.nomeMorador)}}</div>
              <div class="pt-1 letra">Empreendimento: {{data.empreendimentoNovaUnidade.nomeEmpreendimento}}</div>
              <!-- <div class="pt-1 letra">Patologia: {{data.patologiaText}}</div> -->
              <div class="d-flex justify-content-between">
                <div :style="'color:' + data.colorStusOcorencia" class="pt-1 status-letra status-item-info">Status: {{data.statusOcorrenciaName}}</div>
                <div v-if="data.dataSolicitacaoFormatada != null" class="pt-1 letra-calender status-item-info"><i class="fas fa-calendar"></i>{{data.dataSolicitacaoFormatada}}</div>
              </div>
            </div>
          </div>
        </draggable>
        </div>
    </div>
  </div>
  </div>
</template>

<script>
import Kanban from './kanban.js'
export default Kanban
</script>

<style scoped>
.pt-1 {
  font-family: "Segoe UI";
}

.p-2 {
    padding: 0.8rem !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: space-around !important;
}

:deep(.p-scrollpanel-bar) {
  background: #80808096 !important;
}
.fa-calendar{
  padding: 2px;
}
.sortable-ghost {
  border: 1px solid grey;
  font-size: 0;
  overflow: hidden;
}
.status-item-info{
  font-weight: bold ;
}
.iconeimagem{
  width: 25px;
  position: absolute;
  right: 9px;
  top: 7px;
}
.linha {
  display: block;
  overflow: hidden;
  border-style: inset;
  border-width: 1px;
  border-color: #46404617;
}
/* width */
::-webkit-scrollbar {
  visibility: hidden;
  width: 10px;
}
.classtotal{
  height: 30px;
  width: 30px;
  background: grey;
  display: flex;
  font-size: 16px;
  font-weight: bold;
  justify-content: center;
  border-radius: 10px;
  align-items: center;
  color: white;
  font-family: "Segoe UI";
}

/* Track */
::-webkit-scrollbar-track {
  visibility: hidden;
  background: #f1f1f1
}
/* Handle */
::-webkit-scrollbar-thumb {
  visibility: hidden;
  background: #888
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.body-kanban{
  overflow: auto;
  display: flex;
  justify-content: center;
  height: 65vh;
}
.status-kaban-item{
  height: 120px;
  width: 15px;
  border-radius: 10px 0 0 10px;
}
.item-kanban{
  height: 120px;
  display: flex;
  cursor: pointer;
  position: relative;
  width: 400px;
  background: white;
}

.footer {
  display: flex;
  justify-content: center;
}
.btn_adicionar_card {
  cursor: pointer;
  background: transparent;
  border: none;
  font-size: 15px;
  font-weight: bold;
}
.name-user{
  text-transform: uppercase;
  font-size: 15px;
  color: #5d5d5d;
  font-weight: bold;
  font-family: "Segoe UI"
}
.nomecoluna{
  text-transform: uppercase;
  display: flex;
  font-size: 15px;
  color: #727272;
  font-weight: bold;
  font-family: "Segoe UI";
}
.estrelas {
  align-self: bottom;
}
.btnapagar {
  cursor: pointer;
  background: transparent;
  border: none;
}
.kanban-item{
  height: 100px;
}

.btneditar {
  cursor: pointer;
  background: transparent;
  border: none;
}
.head-kanban{
  padding: 5px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.kanban-column {
  min-height: 300px;
}
.item-kanban {
  font-size: 15px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 10px 15px 16px #0000000a;
  border-radius: 10px;
  opacity: 1;
  max-width: 350px;
  margin-bottom: 15px;
}
  /* border: 1px solid black; */

.solicitacao {
  grid-area: 1 / 1 / 2 / 2;
  cursor: pointer;
  font-family: "Source Sans Pro";
  font-size: 15px;
}
.botoes {
  grid-area: 1 / 2 / 2 / 3;
  display: flex;
  justify-content:flex-end;
}
.usuario {
  font-family: "Source Sans Pro";
  font-size: 13px;
  grid-area: 3 / 1 / 4 / 3;
  cursor: pointer;
}
.estrelas {
  grid-area: 4 / 1 / 5 / 2;
}
.valor {
  grid-area: 4 / 2 / 5 / 3;
  display: flex;
  justify-content: end;
  color: #18be5a;
  font-family: "Source Sans Pro";
  font-size: 15px;
}

.g-kanban {
  display: flex;
  gap: 20px;
}

.conteudo-coluna {
  overflow: scroll;
  overflow-x: hidden;
  height: 500px;
}

  .coluna-kanban[data-v-b1d5318a] {
      height: -webkit-fit-content;
      height: -moz-fit-content;
      height: fit-content;
      background: #f6f6f6;
      -webkit-box-shadow: 0px 2px 6px #0000000a;
      box-shadow: 0px 2px 6px #0000000a;
      border-radius: 20px;
      opacity: 1;
      color: #4d4f5c;
      font-family: "Source Sans Pro";
      font-size: 15px;
      min-width: 400px;
      text-align: left;
      padding: 12px;
  }

@media  (max-width: 1280px) {
  .coluna-kanban[data-v-b1d5318a] {
      height: fit-content;
      background: #f6f6f6;
      -webkit-box-shadow: 0px 2px 6px #0000000a;
      box-shadow: 0px 2px 6px #0000000a;
      border-radius: 20px;
      opacity: 1;
      color: #4d4f5c;
      font-family: "Source Sans Pro";
      font-size: 15px;
      min-width: 300px;
      text-align: left;
      padding: 12px;
  }

  .item-kanban {
    font-size: 15px;
    height: fit-content;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 10px 15px 16px #0000000a;
    border-radius: 10px;
    height: 180px;
    opacity: 1;
    max-width: 260px;
    margin-bottom: 15px;
  }

  .status-kaban-item{
  height: 180px;
  width: 15px;
  border-radius: 10px 0 0 10px;
  }

  .p-2 {
    padding: 0.8rem !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: space-around !important;
  }
  .name-user{
    text-transform: uppercase;
    font-size: 13px;
    color: #5d5d5d;
    font-weight: bold;
    font-family: "Segoe UI"
  }
  .pt-1 {
    font-family: "Segoe UI";
  }
  .letra{
    font-size: 11px;
    font-weight: bold;
  }
  .letra-calender {
    font-size: 10px;
    font-weight: bold;
  }
  .status-letra{
    font-size: 12px;
  }
  .body-kanban{
    overflow: auto;
    display: flex;
    justify-content: center;
    height: 100vh;
  }
}

@media (min-width: 1281px ) and (max-width: 1400px){
.p-2 {
    padding: 0.8rem !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: space-around !important;
}

:deep(.p-scrollpanel-bar) {
  background: #80808096 !important;
}
.fa-calendar{
  padding: 2px;
}
.sortable-ghost {
  border: 1px solid grey;
  font-size: 0;
  overflow: hidden;
}
.status-item-info{
  font-weight: bold ;
}
.iconeimagem{
  width: 25px;
  position: absolute;
  right: 9px;
  top: 7px;
}
.linha {
  display: block;
  overflow: hidden;
  border-style: inset;
  border-width: 1px;
  border-color: #46404617;
}
::-webkit-scrollbar {
  visibility: hidden;
  width: 10px;
}
.classtotal{
  height: 30px;
  width: 30px;
  background: grey;
  display: flex;
  font-size: 16px;
  font-weight: bold;
  justify-content: center;
  border-radius: 10px;
  align-items: center;
  color: white;
  font-family: "Segoe UI";
}

::-webkit-scrollbar-track {
  visibility: hidden;
  background: #f1f1f1
}
::-webkit-scrollbar-thumb {
  visibility: hidden;
  background: #888
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.body-kanban{
  overflow: auto;
  display: flex;
  justify-content: center;
  height: 95vh;
}
.status-kaban-item{
  height: 120px;
  width: 15px;
  border-radius: 10px 0 0 10px;
}
.item-kanban{
  height: 120px;
  display: flex;
  cursor: pointer;
  position: relative;
  width: 400px;
  background: white;
}
.footer {
  display: flex;
  justify-content: center;
}
.btn_adicionar_card {
  cursor: pointer;
  background: transparent;
  border: none;
  font-size: 15px;
  font-weight: bold;
}
.name-user{
  text-transform: uppercase;
  font-size: 15px;
  color: #5d5d5d;
  font-weight: bold;
  font-family: "Segoe UI"
}
.nomecoluna{
  text-transform: uppercase;
  display: flex;
  font-size: 16px;
  color: #727272;
  font-weight: bold;
  font-family: "Segoe UI";
}
.estrelas {
  align-self: bottom;
}
.btnapagar {
  cursor: pointer;
  background: transparent;
  border: none;
}
.kanban-item{
  height: 100px;
}

.btneditar {
  cursor: pointer;
  background: transparent;
  border: none;
}
.head-kanban{
  padding: 5px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.kanban-column {
  min-height: 300px;
}
.item-kanban {
  font-size: 15px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 10px 15px 16px #0000000a;
  border-radius: 10px;
  opacity: 1;
  max-width: 350px;
  margin-bottom: 15px;
}

.solicitacao {
  grid-area: 1 / 1 / 2 / 2;
  cursor: pointer;
  font-family: "Source Sans Pro";
  font-size: 15px;
}
.botoes {
  grid-area: 1 / 2 / 2 / 3;
  display: flex;
  justify-content:flex-end;
}
.usuario {
  font-family: "Source Sans Pro";
  font-size: 13px;
  grid-area: 3 / 1 / 4 / 3;
  cursor: pointer;
}
.estrelas {
  grid-area: 4 / 1 / 5 / 2;
}
.valor {
  grid-area: 4 / 2 / 5 / 3;
  display: flex;
  justify-content: end;
  color: #18be5a;
  font-family: "Source Sans Pro";
  font-size: 15px;
}

.g-kanban {
  display: flex;
  gap: 20px;
}
.coluna-kanban {
  height: fit-content;
  background: #f6f6f6;;
  box-shadow: 0px 2px 6px #0000000a;
  border-radius: 20px;
  opacity: 1;
  color: #4d4f5c;
  font-family: "Source Sans Pro";
  font-size: 15px;
  min-width: 400px;
  text-align: left;
  padding: 15px;
}

.conteudo-coluna {
  overflow: scroll;
  overflow-x: hidden;
  height: 500px;
}

}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/components/kanban/kanban.vue